import {EarningsDetail} from './earnings-detail.model';

export class Earnings {
    totalEarnings: EarningsDetail;
    otherEarnings: Array<EarningsDetail>;

    constructor(totalEarnings: EarningsDetail, otherEarnings: Array<EarningsDetail>) {
      this.totalEarnings = totalEarnings;
      this.otherEarnings = otherEarnings;
    }

}




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/points-estimate/earnings.model.ts